import { React, useEffect, useState, Fragment } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

import { Box, Button, Select, MenuItem, TextField } from '@mui/material';
import * as userService from "../../User/api/api";
import * as roleService from "../../Role/api/api";
import * as UserRoleService from "../../UserRole/api/api";
import MyCard from '../../../shared/components/myCard';
import { DataGrid } from '@mui/x-data-grid';

import { toast } from 'react-toastify';
import MyLoading from "src/shared/components/myLoading";




export default function UserRole() {
 const functionSele =(ee)=>{
console.log(ee,"ee")
 }
    
useEffect(() => {
    const pagerInputModel = {
        "pageNumber": 1,
        "pageSize": 20,
        "getPhoto": false
    }
    userService.list(pagerInputModel).then((res) => {
        const { isSuccess,message, data: userData } = res;
        if (isSuccess) {
            setUserList(userData);
        } else {
            toast.error(message);
            console.log(res, "userData-hata");
        }        
    });

  
}, [])

const [isLoading, setIsLoading] = useState(false);

const [userRoleData, setUserRoleData] = useState([]);

const [selectionModel, setSelectionModel] = useState([]);

const [roleList, setRoleList] = useState([]);

useEffect(() => {
    //ilk yuklemede tum menuler 
    const pagerInputModel = {
               
    }
    roleService.list(pagerInputModel).then((res) => {
        const { isSuccess,message, data: roleTmpData } = res;
        if (isSuccess) {
            setRoleList(roleTmpData);
        } else {
            toast.error(message);
            console.log(res, "setRoleList-hata");
        }        
    });
}, [])

const addRoleToUser =(roleId)=>{
    setIsLoading(true);
    const pagerInputModel = {
        "roleId": roleId[0],
        "userId":user           
    }
    UserRoleService.create(pagerInputModel).then((res) => {
        const { isSuccess,message, data: rolMenuData } = res;
        if (isSuccess ) {
            toast.success("Eklendi.");
            getUserRoles(user);

        } else {
            toast.error(message);
            console.log(res, "UserRole create-hata");
        }   
        setIsLoading(false);
     
    });
}
const deleteRoleFromUser =(roleId)=>{
    setIsLoading(true);
console.log(userRoleData,"userRoleData");
    var id= userRoleData.find(p=>p.roleId==roleId).id;
    const pagerInputModel = {
        "id":id           
    }
    UserRoleService.deleteItem(pagerInputModel).then((res) => {
        const { isSuccess,message, data: tmpdatadata } = res;
        if (isSuccess ) {
            getUserRoles(user);
            toast.success("Silindi.");
        } else {
            toast.error(message);
            console.log(res, "deleteItem-hata");
        }     
        setIsLoading(false);
   
    });
}
 function getUserRoles(userId){

    const pagerInputModel = {
        "userId": userId,
    }
    UserRoleService.getList(pagerInputModel).then((res) => {
        const { isSuccess,message, data: rData } = res;
        if (isSuccess || message=='Data is empty') {
            setUserRoleData(rData)
            setSelectionModel(rData.map(p=>p.roleId))
        } else {
            toast.error(message);
            console.log(res, "UseruserList-hata");
        }        
    });

 }

const [userList, setUserList] = useState([]);
    const [user, setUser] = useState(0);

    function userSelectChangeHandler(event) {
        setUser(event.target.value);
        getUserRoles(event.target.value);
       
    }

    const columns = [
        { field: 'name', headerName: 'Rol Adı', width:200 },
        { field: 'id', headerName: 'id', width: 300 }
        
      ]



  return (
    <>
     <MyCard header="Kullanıcıya Role Ekle/Çıkar">
    <Select fullWidth
                    labelId="lblUserId"
                    id="selectUser"
                    value={user}
                    label="User"
                    size="small"
                    onChange={(event) => userSelectChangeHandler(event)}
                >
                    {
                        userList.map((itm) =>
                            <MenuItem value={itm.id}>{itm.name + " " + itm.surname + " /  " + itm.email}</MenuItem>
                        )

                    }
                </Select>
                {isLoading && <MyLoading></MyLoading>}
                <div style={{ height: 700, width: '100%',marginTop:20 }}>
                    
              { user !=0  && <DataGrid
        rows={roleList}
        columns={columns}
        checkboxSelection
       
                onSelectionModelChange={(newSelectionModel) => {
                    console.log(selectionModel,newSelectionModel)
                    var difference;
                    if(selectionModel.length<newSelectionModel.length)
                    {
                           difference = newSelectionModel.filter(x => !selectionModel.includes(x));
                           console.log(difference,"eklendi");
                           addRoleToUser(difference)
                          
                    }
                      else  if(selectionModel.length>newSelectionModel.length)
                      {
                             difference = selectionModel.filter(x => !newSelectionModel.includes(x));
                             deleteRoleFromUser(difference);
                             console.log(difference,"cikarildi");
                      }


            setSelectionModel(newSelectionModel);
          }}
          selectionModel={selectionModel}
         pageSize={80}
      />}
      </div>
    </MyCard>
    
    
    </>
  )
}
